import { render, staticRenderFns } from "./TrashList.vue?vue&type=template&id=304c919b&"
import script from "./TrashList.vue?vue&type=script&lang=js&"
export * from "./TrashList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports